import React, { Component } from 'react'
import axios from 'axios'
import {
  Form,
  FormGroup,
  Button,
  ControlLabel,
  FormControl,
  InputGroup,
  ListGroup,
  ListGroupItem,
} from 'react-bootstrap'
import Modal from 'antd/lib/modal'
import Icon from 'antd/lib/icon'

import LoaderButton from '../components/LoaderButton'
import config from '../config.js';

//import 'antd/dist/antd.css'
import 'antd/lib/modal/style/css'
import './Home.css'


class Home extends Component {

  constructor(props) {
    super(props);

    this.stateInit = {
      businessCategory: null,
      otherCategoryDesc: '',
      businessScale: null,
      selectedPlan: null,

      companyName: '',
      fullname: '',
      email: '',
      phoneNum: '',
      comments: '',
      showCommentsTextArea: false,
    };

    this.state = {
      ...this.stateInit
    }

    this.plans = [
      {id:'2004', title:"2 Months' Free Trial", desc:"6 Stores and above", months:2, isFree: true},
      {id:'2001', title:"3 Months' Free Trial", desc:"Up to 5 stores", months:3, isFree: true},
      {id:'2002', title:"6 Months' Free Trial", desc:"For one store, extendable", months:6, isFree: true},
      {id:'2003', title:"1 Year's Free Subscription", desc:"For one store, extendable", months:12, isFree: true},
      {id:'1001', title:"1 Year's Membership", desc:"Single Store, $19 / month ", months:12},
      {id:'1003', title:"1 Year's Membership of Store SUPER", desc:"6 Stores and above", months:12},
      {id:'1002', title:"1 Year's Membership of Store PLUS", desc:"Up to 5 Stores, $89 / month", months:12},
    ]

    this.plansById = this.plans.reduce((map,obj)=>{
      map[obj.id] = obj;
      return map
    },{})

    this.storeScales = [
      {id:1, min:1, max:1, plans:['2002','2003','1001',]},
      {id:2, min:2, max:5, plans:['2001','2002','1002']},
      {id:6, min:6, max:10, plans:['2004','2001','1002','1003']},
      {id:11, min:11,  plans:['2004','2001','1002','1003'] },
    ]

    this.storeScalesById = this.storeScales.reduce((map,obj)=>{
      map[obj.id] = obj;
      return map
    },{})

    this.businessCategories = [
      {id:1001, name:'Food and Beverage', plans:['2001','2002','2004','1001','1002','1003']},
      {id:1002, name:'Groceries', plans:['2001','2002','2004','1001','1002','1003']},
      {id:1003, name:'Beauty & Health', plans:['2001','2002','2004','1001','1002','1003']},
      {id:1004, name:'NPO',   plans:['2001','2002','2004','2003','1001','1002','1003']},
      {id:1005, name:'Others', plans:['2001','2002','2004','1001','1002','1003']},
    ]

    this.businessCategoresById = this.businessCategories.reduce((map,obj)=>{
      map[obj.id] = obj;
      return map
    },{})

    this.descStoreScale = (item)=>{
      if(item.min === item.max){
        return `${item.min} store${item.min===1?"":"s"}`
      }
      else if(!item.max){
        return `more than ${item.min-1} stores`
      }
      else {
        return `${item.min} - ${item.max} stores`
      }
    }

    this.plansAvailable = () => {

      if( !this.state.businessCategory || !this.state.businessScale ){
        return []
      }

      return this.plans.filter( plan => {
        return this.state.businessCategory.plans.indexOf(plan.id) !== -1
      }).filter( plan => {
        return this.state.businessScale.plans.indexOf(plan.id) !== -1
      })
    }
  }

  async componentDidMount() {
    if( this.props.userToken){
      console.log( "Logged in" );
    }
  }

  render() {
    return (
      <div>
        <this.Header />
        <this.Scenarios />
        <this.Products />
        <this.Contact />
        <this.AboutUs />
      </div>
    );
  }

  Header = ()=>{
    return (
      <header className="masthead" id='top'>
        <div className="container" style={{
            paddingTop: 60,
            paddingBottom: 60,
          }}>
          <div className="intro-text" >
            <div className="intro-heading" style={{
                color: '#ffffff',
                textShadow: '0px 2px gold',
              }}>
              New way of <br/> connecting customers
            </div>

            <div className="intro-lead-in">
              <a className="product-name"> Retail Knack </a>
              is a software  toolkit
              connect your business <br/> closely  with your customers.
            </div>
            <div>
              <a className="btn btn-xl js-scroll-trigger" href="#contact"
                style={{borderRadius: 10,
                  paddingLeft: 20,
                  paddingRight: 30,
                  color: '#FFFFFF',
                  fontSize: 22,
                }}>
                <img className="img-fluid"
                  src="/img-customize/logos/logo.png" alt=""
                  style={{
                    width: 50,
                    backgroundColor: 'transparent',
                    paddingBottom: 3,
                    paddingRight: 5,
                  }}/>
                Request Free Trial
                </a>
            </div>
            <div style={{
              marginTop: 10,
              marginLeft: 20,
              color: 'black',
            }}>
              <a target='_blank' href="/signup-invited" style={{
                marginTop: 10,
                marginLeft: 20,
                fontSize: 16,
                color: '#FF2222',
                textDecorationLine: 'underline',
                backgroundColor: 'rgba(255,255,255,0.5)',
                borderRadius: 2,
              }}>Have an invitation code? click HERE >> </a>

            </div>

          </div>
        </div>
      </header>
    )
  }

  Scenarios = ()=>{
    return (
      <section id="scenarios" style={{
          paddingTop: 150,
          paddingBottom: 80,
          backgroundColor: '#F0F0F0',
        }}>
        <div className="container" >
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-heading" style={{
                  color:'#555555',
                  fontWeight: 800,
              }}>If you're thinking of </h2>
              <h3 className="section-subheading " style={{
                  color:'#FF5555',
                  fontFamily:'Kalam,cursive',
                  fontSize:40,
                  fontWeight:700}} >
                Listen to your customer's heartbeat: </h3>
            </div>
          </div>
          <div className="row text-center">
            <div className="col-md-4" style={{marginBottom:20}}>
              <span className="fa-stack fa-4x">
                <i className="fa fa-circle fa-stack-2x text-primary" ></i>
                <img src="/img-customize/hearing.png" style={{
                    width:'80%',
                    position:'absolute',
                    left: 10,
                    top: 20,
                  }} alt=''></img>
              </span>
              <h4 className="service-heading">Hear from your customer</h4>
              <p className="text-muted" style={{fontSize:17}}> Complain, Compliment or Suggestion?
                 Listen to customer is helpful for improving your product and service,
                 also, when customer feel connected, they tend to come back and spend more.
              &nbsp;But we know that getting useful feedback is hard,
                &nbsp;so we build software to make it easier for you.</p>
            </div>
            <div className="col-md-4" style={{marginBottom:20}}>
              <span className="fa-stack fa-4x">
                <i className="fa fa-circle fa-stack-2x text-primary"></i>
                <img src="/img-customize/launch.svg" alt='' style={{
                    width:'60%',
                    position:'absolute',
                    left: 20,
                    top: 28,
                    }}></img>

                  <img src="/img-customize/yes.svg" alt='' style={{
                    width:25,
                    position:'absolute',
                    left: 15,
                    top: 20,
                    }}></img>
              </span>
              <h4 className="service-heading">Launch new product</h4>
              <p className="text-muted" style={{fontSize:17}}>Test a new product?  is it good enough to carry on for every store?
                WHAT needs to be improved?  and HOW? Study customer's feedback to kick-start your answer,
                Got your feedback FAST and improve your product FAST!
                Don't miss the chance to improve your product at the RIGHT TIME, use the right tools! </p>
            </div>
            <div className="col-md-4" style={{marginBottom:20}}>
              <span className="fa-stack fa-4x">
                <i className="fa fa-circle fa-stack-2x text-primary"></i>
                <img src="/img-customize/store.svg" alt='' style={{
                    width:70,
                    position:'absolute',
                    left: 15,
                    top: 15,
                  }}/>
                <div style={{
                  width: 45,
                  height: 45,
                  position:'absolute',
                  left: 0,
                  top: 12,
                  borderRadius: '100%',
                  padding: 7,
                  backgroundImage: `url("/img-customize/plus-red.svg")`,
                  backgroundSize: 45,
                  backgroundClip: 'content-box',
                  backgroundColor: 'gold',
                }}></div>
              </span>
              <h4 className="service-heading">Open a new shop</h4>
              <p className="text-muted" style={{fontSize:17}}> Majority of your customers are new customer,
                sale data always late for important things, and you have more decision to make..
                Support needed? One important support is your dear customer's feedback, and use a survey do help too.
                we believe you will be happy to have our tool deployed from day one of your new store  </p>
            </div>
          </div>
        </div>
      </section>
    )
  }

  Products = ()=> {
    return <section id="products" className="bg-light" style={{
        paddingTop: 150,
        backgroundColor: '#F8F9FA',
      }}>
      <div className="container" >
        <div className="row" style={{marginBottom:20}}>
          <div className="col-lg-2"/>
          <div className="col-lg-8 text-center">
            <h2 className="section-heading" style={{
              color:'#333333',fontWeight:'bold', }}>
              YOU may find right tools
            </h2>
            <h3 style={{color:'#333333',fontWeight:'bold', fontSize:32,}}> make it easier:</h3>
            <h3 className="text-muted" style={{
                lineHeight:1.8, marginTop:10, fontSize:18, textTransform:'none'}}>
              We built software systems that capture your customer's feedbacks
              in various convenient ways, timely report to you,
              let data ready for your decision making and
              business's scaling up
            </h3>
          </div>
          <div className="col-lg-2"/>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <ul className="timeline">
              <li>
                <div className="timeline-image" style={{
                  backgroundColor: 'rgb(239,239,239)',
                  backgroundClip: 'content-box',
                  padding: 0,
                  borderColor: 'transparent',
                  borderWidth: 10,
                  color: 'black',
                  fontSize: 12,
                  fontWeight: 300,
                  textAlign: 'center',
                  position: 'relative',
                  top: -10,
                }}>
                  <img className="rounded-circle img-fluid"
                    src="/img-customize/consumer-3.svg" alt=""
                    style={{
                      width: '100%',
                      backgroundColor: 'transparent',
                      borderWidth: 0,
                      borderColor: 'white',
                    }}/>
                </div>
              </li>
              <li>
                <div className="timeline-image" style={{
                  backgroundColor: 'white',
                  padding: 5,
                  borderWidth: 5,
                  borderColor: 'light-grey',
                }}>
                  <img className="img-fluid"
                    src="/img-customize/storeapp.png" alt=""
                    style={{
                      width: '100%',
                      backgroundColor: 'transparent',
                      padding: 0,
                      borderRadius: '100%',
                    }}/>
                </div>
                <div className="timeline-panel">
                  <div className="timeline-heading" >
                    <h3 style={{fontWeight: 800,}}>Store App </h3>
                    <h4 className="subheading" style={{
                        fontWeight: 600,
                        marginTop:10,
                        marginBottom:10
                      }}>
                      Connect your customer in seconds
                    </h4>
                  </div>
                  <div className="timeline-body">
                    <p className="text-muted" style={{ fontSize:17,}}>
                      <Icon type="star-o" style={{ }}/>&nbsp;
                        Enable consumer to initiate a feedback in seconds,
                         by App, QR Code or Both.
                    </p>
                    <p className="text-muted" style={{fontSize:17, }}>
                      <Icon type="star-o" />&nbsp;
                      Customizable UI, suit your store's style
                    </p>
                    <p className="text-muted" style={{fontSize:17, }}>
                      <Icon type="star-o" />&nbsp;
                      Different deploy options, lower cost
                    </p>
                  </div>
                </div>
              </li>

              <li className="timeline-inverted">
                <div className="timeline-image" style={{
                  backgroundColor: 'white',
                  borderWidth: 5,
                  borderColor: 'light-grey',
                  padding: 5,
                }}>
                  <img className="rounded-circle img-fluid"
                    src="/img-customize/consumer-app.png" alt=""
                    style={{
                      width: '80%',
                      height: '100%',
                      padding: 0,
                      backgroundColor: 'transparent',
                    }}/>
                </div>
                <div className="timeline-panel">
                  <div className="timeline-heading">
                    <h3 style={{fontWeight: 800,}}>Consumer App</h3>
                    <h4 className="subheading" style={{
                        fontWeight: 600, marginTop:10, marginBottom:10}}>
                      Smooth yet Powerful
                    </h4>
                  </div>

                  <div className="timeline-body">
                    <p className="text-muted" style={{ fontSize:17,}}>
                      <Icon type="star-o" style={{ }}/>&nbsp;
                        No spam, only feedback for your store, build the trust with your customers
                    </p>
                    <p className="text-muted" style={{fontSize:17, }}>
                      <Icon type="star-o" />&nbsp;
                      Extendable, suit your business need.
                    </p>
                    <p className="text-muted" style={{fontSize:17, }}>
                      <Icon type="star-o" />&nbsp;
                      Customizable, branding your organization & product
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div className="timeline-image" style={{
                  backgroundColor: 'white',
                  borderWidth: 5,
                  borderColor: 'light-grey',
                  padding: 0,
                }}>
                  {
                    <img className="rounded-circle img-fluid"
                      src="/img-customize/dashboard-logo.png" alt=""
                      style={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'transparent',
                      }}/>
                  }
                </div>
                <div className="timeline-panel">
                  <div className="timeline-heading">
                    <h3 style={{fontWeight: 800,}}>Dashboard</h3>
                    <h4 className="subheading" style={{
                        fontWeight: 600, marginTop:10, marginBottom:10
                      }}>
                      Magic mirror of your business...
                    </h4>
                  </div>
                  <div className="timeline-body">
                    <p className="text-muted" style={{ fontSize:17,}}>
                      <Icon type="star-o" style={{ }}/>&nbsp;
                        Switchable real time Notifications
                    </p>
                    <p className="text-muted" style={{fontSize:17, }}>
                      <Icon type="star-o" />&nbsp;
                      Weekly / Daily Reports
                    </p>
                    <p className="text-muted" style={{fontSize:17, }}>
                      <Icon type="star-o" />&nbsp;
                      Up to date statistics
                    </p>
                    <p className="text-muted" style={{fontSize:17, }}>
                      <Icon type="star-o" />&nbsp;
                      Online store device monitoring
                    </p>
                    <p className="text-muted" style={{fontSize:17, }}>
                      <Icon type="star-o" />&nbsp;
                      And more...
                    </p>
                  </div>
                </div>
              </li>
              <li className="timeline-inverted" style={{
                }}>
                <div className="timeline-image" style={{
                    backgroundColor: 'gold',
                    borderWidth: 0,
                  }}>
                  <div style={{height:'100%',marginTop: 20,}}>
                    <h4 style={{
                        fontWeight: 600,
                      }}>
                      Learn <br/>with Free <br/>Trial
                    </h4>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  }

  Contact = () => {
    return (
      <section id="contact" style={{
        backgroundColor: '#EEEEEE',
        backgroundImage: 'none',
        paddingTop: 100,
        marginTop: -30,
      }}>
        <div className="container bg-sgmap" style={{
            paddingTop: 80,
            paddingBottom: 100,
            // backgroundRepeat: 'no-repeat',
            // backgroundPosition: 'top center',
            // backgroundSize: 450,
            // backgroundImage: `url("/img-customize/singapore-map.png")`,
          }}>
          <div className="row" style={{
          }}>
            <div className="col-lg-12 text-center">
              <h2 className="section-heading" style={{color:'#333333', fontWeight:700,}}>
                Request free Trial </h2>
              <h3 style={{marginTop: 5, marginBottom: 5,
                  color:'#666666',
                  fontWeight:'bold',
                  fontSize: 24,
                }}>to Boost Your Business</h3>
              <h3 className="section-subheading text-muted" style={{
                  fontFamily: 'Roboto', fontSize: 24,  fontWeight:800, lineHeight:1.5,
                  marginBottom: 10,
                }}>
                  <div style={{fontSize: 20,
                  }}>If you have an&nbsp;
                    <text style={{color:'#FF4444'}}>Invitation Code</text>
                      &nbsp;please&nbsp;
                      <Button bsSize="small" bsStyle='primary' target='_blank'
                        onClick={()=>{window.location.href='/signup-invited'
                        }}>click here
                      </Button>
                  </div>
                  <div style={{
                      fontSize: 20,
                      color:'#555555',
                  }}>
                    Or just choose a plan suit your business :
                  </div>
                </h3><br/><br/>
            </div>
          </div>
          <div className="row"  style={{}}>
            <div className="col-lg-12" style={{
                //textAlign:'center'
                display: '-webkit-box',  /* OLD - iOS 6-, Safari 3.1-6, BB7 */
                display: '-ms-flexbox',  /* TWEENER - IE 10 */
                display: '-webkit-flex', /* NEW - Safari 6.1+. iOS 7.1+, BB10 */
                display: 'flex',         /* NEW, Spec - Firefox, Chrome, Opera */

                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Form onSubmit={this.handleSubmit} style={{
                  width: 500,
                  fontSize: 16,
                  fontWeight: 500,
                  color: '#606060',
                //  minWidth:'400',alignSelf:'center',marginLeft:'25%',marginRight:'25%'
                }}>
                <FormGroup controlId="formControlsSelect">
                  <ControlLabel>Your business sector : </ControlLabel>
                  <FormControl componentClass="select"
                    placeholder="select"
                    onChange={ this.onSelectBusinessCat }
                    value={ this.state.businessCategory ? this.state.businessCategory.id : 'selet'}
                    >
                    <option value="select">- select -</option>
                    {
                      this.businessCategories.map(
                        item=><option value={item.id} key={item.id}>{item.name}</option>)
                    }
                  </FormControl>

                </FormGroup>
                {(this.state.businessCategory && this.state.businessCategory.name === 'Others' )&&
                  <FormGroup controlId="otherCategoryDesc">
                    <div style={{ marginTop: -10}}>
                      <FormControl
                        autoFocus
                        componentClass="input"
                        type="text"
                        style={{
                          height:20,
                          textTransform: 'none',
                        }}
                        placeholder="Your business sector"
                        value={this.state.otherCategoryDesc}
                        onChange={this.handleChange} />
                    </div>
                  </FormGroup>
                }
                <FormGroup controlId="formControlsSelectScale">
                  <ControlLabel>How many stores/locations in Singapore?</ControlLabel>
                  <FormControl componentClass="select"
                    placeholder="select"
                    onChange={ this.onSelectBusinessScale }
                    value={ this.state.businessScale ? this.state.businessScale.id : 'selet'}
                    >
                    <option value="select">- select -</option>
                    {
                      this.storeScales.map(
                        (item)=><option value={item.id} key={item.min}>{this.descStoreScale(item)}</option>)
                    }
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  {
                    //<ControlLabel>Please Select</ControlLabel>
                    this.plansAvailable().map(item=>{
                      const itemSelected = this.state.selectedPlan === item.id
                      const pp = {active: itemSelected}
                      return  <ListGroupItem header={item.title} key={item.id} {...pp}
                                style={{
                                  fontFamily: 'Roboto',
                                  wordSpacing: 2,
                                  letterSpacing: 0.01,
                                  color: `${item.isFree? '#11DD11':'#EECE00'}`,
                                  textAlign: 'left',
                                  //backgroundColor,
                                }}
                                onClick={(e)=>{
                                  this.setState({
                                    selectedPlan: item.id
                                  })}}
                                >
                                <text style={{
                                    fontFamily: 'Roboto',
                                    color: '#BBBBBB'
                                  }}>{item.desc}
                                </text>
                                { // itemSelected &&
                                  <Button bsStyle="primary" bsSize='small'
                                    disabled={itemSelected}
                                    style={{position: 'absolute', right:10,top:15}}
                                    > {itemSelected?"Selected":"SELECT"}
                                  </Button>
                                }
                              </ListGroupItem>
                    }).reduce( (result, item) =>{
                        result.list.push( item )
                        if( result.list.length === 1  ){
                          // only need to assign once
                          result.render = ()=>{
                            return <ListGroup style={{backgroundColor:'white'
                              }}>
                                <ListGroupItem  style={{backgroundColor:'white'
                                  }} >Available Plans for your organization: </ListGroupItem>

                                {result.list.map(item=>item)}
                                {this.state.selectedPlan ?
                                  <ListGroupItem disabled style={{color:'grey',backgroundColor:'white'}}>
                                    Plan choosed: {this.plansById[this.state.selectedPlan].title}
                                  </ListGroupItem>
                                  :
                                  <ListGroupItem disabled style={{color:'grey',backgroundColor:'white'}}>
                                    - Please select a plan to continue -
                                  </ListGroupItem>
                                }
                              </ListGroup>
                          }
                        }
                        return result;
                    }, {
                      list:[],
                      render:()=>
                        <div style={{color:'#CCCCCC'}}>
                          <ListGroup>
                            <ListGroupItem disabled style={{backgroundColor:'white'
                              }}>Available Plans for your organization: </ListGroupItem>
                            {this.state.selectedPlan ?
                              <ListGroupItem disabled style={{
                                  color:'grey',backgroundColor:'white'
                                }}> Plan selected: {this.plansById[this.state.selectedPlan].title}</ListGroupItem>
                              :<ListGroupItem disabled style={{
                                color:'#FF8888',backgroundColor:'white'
                              }}>Plans base on the info you provided </ListGroupItem>
                            }
                          </ListGroup>
                        </div>
                    }).render()
                  }
                </FormGroup>
                { this.state.selectedPlan &&
                <div style={{width:'100%'}}>
                  <FormGroup controlId="companyName" bsSize="large" style={{textAlign:'left', marginBottom:10}}>
                    <ControlLabel >Your Company / Store Name:</ControlLabel>
                    <FormControl style={{height:20}}
                      type="text"
                      value={this.state.companyName}
                      placeholder="Company Name"
                      onChange={this.handleChange} />
                  </FormGroup>
                  <FormGroup controlId="fullname" bsSize="large" style={{
                      textAlign:'left',
                      marginBottom:10,
                    }}>
                    <ControlLabel >Your Full Name</ControlLabel>
                    <FormControl style={{
                        height:20,
                        textTransform: 'none',
                      }}
                      type="text"
                      placeholder='Joy Lim'
                      value={this.state.fullname}
                      onChange={this.handleChange}
                       />
                  </FormGroup>
                  <FormGroup controlId="email" bsSize="large"
                    style={{
                      textAlign:'left', marginBottom:10
                    }}>
                    <ControlLabel>Email address</ControlLabel>
                    <FormControl style={{height:20}}
                      value={this.state.email}
                      onChange={this.handleChange}
                      placeholder='joylim@example.com'
                      type="email" />
                  </FormGroup>
                  <FormGroup controlId="phoneNum" bsSize="large" style={{
                      textAlign:'left', marginBottom:20
                    }} >
                    <ControlLabel >Phone Number (To receive invitation code upon approve)
                    </ControlLabel>
                    <InputGroup style={{
                      }}>
                      <InputGroup.Addon style={{
                      //    height:37,marginTop:0.5
                        }}>+65
                      </InputGroup.Addon>
                      <FormControl style={{height:20}}
                        type="number"
                        placeholder='12341234'
                        value={this.state.phoneNum}
                        onChange={this.handleChange}
                        />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup controlId="comments" bsSize="large" style={{
                      textAlign:'left',
                      marginBottom:5,
                    }}>
                    <ControlLabel>
                      <a style={{
                          textDecorationLine: 'underline',
                          color: 'grey',
                        }}
                        onClick={(event)=>{
                          event.preventDefault();
                          this.setState({
                            showCommentsTextArea: !this.state.showCommentsTextArea,
                          })
                        }}>
                        Anything else? (Optional)
                      </a>
                    </ControlLabel>
                    { this.state.showCommentsTextArea &&
                      <FormControl style={{
                          textTransform: 'none',
                        }}
                        componentClass="textarea"
                        value={this.state.comments}
                        onChange={this.handleChange}
                        maxLength={500}
                        placeholder='Tell us more about your store, needs and timeline'
                         />
                    }
                  </FormGroup>
                  <br/>
                </div>
                }
                <LoaderButton
                  bsSize = 'large'
                  style={{
                      color: 'white',
                      borderColor: '#fed136',
                      backgroundColor: '#fed136',
                      fontFamily: 'Montserrat',
                      fontWeight: 'bold',
                      width: 220,
                    }}
                  disabled={ !this.checkFormValid() }
                  type="submit"
                  isLoading={this.state.isLoading}
                  text="Send Request"
                  loadingText="Sending Request .." />
              </Form>
            </div>
          </div>

        </div>
      </section>
    )
  }


  AboutUs = () => {

    return (
      <section id="about"  style={{
        backgroundColor: '#F8F9FA',
        backgroundImage: 'none',
        paddingTop: 0,
        marginTop: -30,
      }}>
        <div className="container my-container" style={{
            paddingTop: 100,
            paddingBottom: 200,
            // backgroundRepeat: 'no-repeat',
            // backgroundPosition: 'top center',
            // backgroundSize: 100,
            // opacity: 1.0,
            // backgroundImage: `url("/img-customize/lionhead-sg.png")`,
          }}>
          <div className="row" style={{
          }}>

            <div className="col-lg-3 text-center"/>
            <div className="col-lg-6 text-center">

              <h2 className="section-heading" style={{
                color:'#333333',
                fontWeight:700,
              }}>
                About Us
              </h2>
              <h4 className="service-heading">Who we are</h4>
              <p className="text-muted" style={{fontSize:17 , fontWeight: 'bold', color:'#555555'}}>
                We are Yading-Soft , A Singapore based software company, we create
                Retail Knack in the way of SaaS (software as a service) to serve SME retailers.
              </p>
              <h4 className="service-heading">Our Mission</h4>
              <p className="text-muted" style={{fontSize:17,fontWeight: 'bold',  color:'#555555'}}>
                Let every retailer's business pulse together with consumers,
                  using affordable & latest technology.
              </p>

              <h4 className="service-heading">What we Believe</h4>
              <p className="text-muted" style={{fontSize:17, fontWeight: 'bold', color:'#555555'}}>
                We believe latest IT is not only for big company, more affordable
                software service will to open to SMEs, which is as powerful as what big company has.

              </p>


            </div>
            <div className="col-lg-3 text-center"/>
          </div>
          <div className="row"  style={{}}>
            <div className="col-lg-12" style={{
                textAlign: 'center',
                marginTop: 20,
                // display: '-webkit-box',  /* OLD - iOS 6-, Safari 3.1-6, BB7 */
                // display: '-ms-flexbox',  /* TWEENER - IE 10 */
                // display: '-webkit-flex', /* NEW - Safari 6.1+. iOS 7.1+, BB10 */
                // display: 'flex',         /* NEW, Spec - Firefox, Chrome, Opera */
                // justifyContent: 'center',
                // alignItems: 'center',
              }}>
              <h4 style={{color:'grey', fontWeight:'bold'}}>Contact US <br/></h4>
              <p className="text-muted" style={{fontSize:17, }}>
                <Icon type="mail" />&nbsp; tan@retailknack.com
              </p>
              <p className="text-muted" style={{ fontSize:17,}}>
                <Icon type="phone" style={{ }}/>&nbsp;(+65) 98309078
              </p>
            </div>
          </div>

        </div>
      </section>
    )
  }


  checkFormValid = () =>{
    return this.state.companyName.length > 0
      && this.state.email.length > 0
      && this.state.phoneNum.length > 6
      && this.state.fullname.length > 1
      && this.state.selectedPlan
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    })
  }

  onSelectBusinessCat = (e )=>
  {
    this.setState({
      businessCategory: this.businessCategoresById[e.target.value],
      selectedPlan: null,
    })
  }

  onSelectBusinessScale = (e )=>
  {
    this.setState({
      businessScale: this.storeScalesById[e.target.value],
      selectedPlan: null,
    })
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ isLoading: true });

    try {
      const url = `${config.apiGateway.URL_WWW}registerrequest`
      await axios.post(url, {
        companyName: this.state.companyName,
        phoneNum: this.state.phoneNum,
        email: this.state.email,
        fullname: this.state.fullname,
        comments: this.state.comments,
        businessCategory: this.state.businessCategory.id,
        otherCategoryDesc: this.state.otherCategoryDesc,
        businessScale: this.state.businessScale.id,
        planID: this.state.selectedPlan,
      })
      .then( (result)=>{

        Modal.success({
          okText: 'OK',
          title: 'You Request Received',
          content:  <div style={{marginBottom:-20}}>
                      We just sent a confirmation email to {this.state.email},
                     and our colleague will contact you soon. <br/>
                   Your greater success is our mission !
                    </div>,
          onOk: ()=>{
            this.setState({
              ...this.stateInit,
            })
            window.location.href = '/#page-top'
          }
       })

        console.dir( result )
      })

    }
    catch(e) {
      console.dir(e)
      Modal.error({
        okText: 'OK',
        title: 'Oops',
        content:  <div style={{marginBottom:-20}}>
                    {e.message ? e.message: e }
                  </div>,
        onOk: ()=>{
          // this.setState({
          //   ...this.stateInit,
          // })
          // window.location.href = '/#page-top'
        }
     })

    }

    this.setState({ isLoading: false });
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home.js